import React from 'react';

export interface TactilePanelProps {
  title?: React.ReactNode;
  subtitle?: string;
  badge?: React.ReactNode;
  action?: React.ReactNode;
  elevation?: 'flat' | 'machined' | 'elevated' | 'well';
  className?: string;
  children: React.ReactNode;
}

export const TactilePanel: React.FC<TactilePanelProps> = ({
  title,
  subtitle,
  badge,
  action,
  elevation = 'machined',
  className = '',
  children,
}) => {
  const elevationStyles = {
    flat: 'bg-shop-dark border border-shop-border',
    machined: 'bg-shop-dark border border-shop-border shadow-machined',
    elevated: 'bg-shop-panel border border-shop-border shadow-tactile',
    well: 'bg-shop-darkest border border-shop-border shadow-tactile-pressed',
  }[elevation];

  return (
    <section
      className={`rounded text-shop-light overflow-hidden transition-all duration-150 ${elevationStyles} ${className}`}
    >
      {(title || subtitle || action || badge) && (
        <header className="px-4 py-3 border-b border-shop-border bg-shop-darkest flex items-center justify-between gap-3">
          <div className="flex items-center gap-2 min-w-0">
            {badge}
            <div className="min-w-0">
              {title && (
                <h3 className="text-sm font-bold uppercase tracking-wider text-shop-highlight truncate">
                  {title}
                </h3>
              )}
              {subtitle && (
                <p className="text-xs text-shop-muted truncate mt-0.5">
                  {subtitle}
                </p>
              )}
            </div>
          </div>
          {action && <div className="flex items-center gap-2 shrink-0">{action}</div>}
        </header>
      )}
      <div className="p-4">{children}</div>
    </section>
  );
};
